// Alaine's Compass — state-by-state regulatory contacts.
    // Compiled July 2026 from USDA NIFA's state food safety extension list, AFDO's
    // permit & license guide, and FDA.gov. Links and agencies change — verify before relying.

    export const REGULATORY_DIRECTORY = [
  {
    "id": "rg-001",
    "kind": "extension",
    "name": "Alabama",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "AL",
    "website": "https://www.aces.edu/blog/category/food-safety/"
  },
  {
    "id": "rg-002",
    "kind": "extension",
    "name": "Alaska",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "AK",
    "website": "https://www.uaf.edu/ces/foods/safety/"
  },
  {
    "id": "rg-003",
    "kind": "extension",
    "name": "Arizona",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "AZ",
    "website": "https://extension.arizona.edu/topics/cooking-food-safety"
  },
  {
    "id": "rg-004",
    "kind": "extension",
    "name": "Arkansas",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "AR",
    "website": "https://www.uaex.uada.edu/life-skills-wellness/food-safety/default.aspx"
  },
  {
    "id": "rg-005",
    "kind": "extension",
    "name": "California",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "CA",
    "website": "http://ucfoodsafety.ucdavis.edu/"
  },
  {
    "id": "rg-006",
    "kind": "extension",
    "name": "Colorado",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "CO",
    "website": "https://extension.colostate.edu/topic-areas/nutrition-food-safety-health/"
  },
  {
    "id": "rg-007",
    "kind": "extension",
    "name": "Connecticut",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "CT",
    "website": "http://www.foodsafety.uconn.edu/"
  },
  {
    "id": "rg-008",
    "kind": "extension",
    "name": "Delaware",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "DE",
    "website": "https://www.udel.edu/academics/colleges/canr/cooperative-extension/nutrition-wellness/food-safety/"
  },
  {
    "id": "rg-009",
    "kind": "extension",
    "name": "Florida",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "FL",
    "website": "https://ask.ifas.ufl.edu/collections/series_food_safety"
  },
  {
    "id": "rg-010",
    "kind": "extension",
    "name": "Georgia",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "GA",
    "website": "http://extension.uga.edu/topic-areas/food-health/commercial-home-food-safety.html"
  },
  {
    "id": "rg-011",
    "kind": "extension",
    "name": "Guam",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "GU",
    "website": "https://cnas-re.uog.edu/expertise/food-safety/"
  },
  {
    "id": "rg-012",
    "kind": "extension",
    "name": "Hawaii",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "HI",
    "website": "https://cms.ctahr.hawaii.edu/ce"
  },
  {
    "id": "rg-013",
    "kind": "extension",
    "name": "Idaho",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "ID",
    "website": "https://www.uidaho.edu/cals/family-and-consumer-sciences/research-and-extension/food-safety"
  },
  {
    "id": "rg-014",
    "kind": "extension",
    "name": "Illinois",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "IL",
    "website": "https://extension.illinois.edu/global/nutrition-and-wellness"
  },
  {
    "id": "rg-015",
    "kind": "extension",
    "name": "Indiana",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "IN",
    "website": "https://extension.purdue.edu/"
  },
  {
    "id": "rg-016",
    "kind": "extension",
    "name": "Iowa",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "IA",
    "website": "https://www.extension.iastate.edu/humansciences/foodsafety"
  },
  {
    "id": "rg-017",
    "kind": "extension",
    "name": "Kansas",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "KS",
    "website": "https://extension.k-state.edu/foodsafety/"
  },
  {
    "id": "rg-018",
    "kind": "extension",
    "name": "Kentucky",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "KY",
    "website": "https://www.mgcafe.uky.edu/academics/programs/masters/nutrition-and-food-systems"
  },
  {
    "id": "rg-019",
    "kind": "extension",
    "name": "Louisiana",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "LA",
    "website": "https://www.lsuagcenter.com/topics/food_health/food/safety"
  },
  {
    "id": "rg-020",
    "kind": "extension",
    "name": "Maine",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "ME",
    "website": "https://extension.umaine.edu/food-health/food-safety/"
  },
  {
    "id": "rg-021",
    "kind": "extension",
    "name": "Maryland",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MD",
    "website": "https://extension.umd.edu/foodsafety"
  },
  {
    "id": "rg-022",
    "kind": "extension",
    "name": "Massachusetts",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MA",
    "website": "https://www.umass.edu/food-science/"
  },
  {
    "id": "rg-023",
    "kind": "extension",
    "name": "Michigan",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MI",
    "website": "https://www.canr.msu.edu/safe_food_water/"
  },
  {
    "id": "rg-024",
    "kind": "extension",
    "name": "Minnesota",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MN",
    "website": "https://extension.umn.edu/food-health-and-nutrition"
  },
  {
    "id": "rg-025",
    "kind": "extension",
    "name": "Mississippi",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MS",
    "website": "http://extension.msstate.edu/food-and-health/food-safety"
  },
  {
    "id": "rg-026",
    "kind": "extension",
    "name": "Missouri",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MO",
    "website": "https://www.lincolnu.edu/cooperative-extension-and-research/programs-and-projects/culinary-incubator.html"
  },
  {
    "id": "rg-027",
    "kind": "extension",
    "name": "Missouri 2",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MO",
    "website": "https://extension.missouri.edu/programs/food-safety"
  },
  {
    "id": "rg-028",
    "kind": "extension",
    "name": "Montana",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "MT",
    "website": "https://www.msuextension.org/"
  },
  {
    "id": "rg-029",
    "kind": "extension",
    "name": "Nebraska",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "NE",
    "website": "https://food.unl.edu/food-safety-preservation"
  },
  {
    "id": "rg-030",
    "kind": "extension",
    "name": "New Hampshire",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "NH",
    "website": "https://extension.unh.edu/agriculture-gardens/food-safety"
  },
  {
    "id": "rg-031",
    "kind": "extension",
    "name": "New Jersey",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "NJ",
    "website": "https://njaes.rutgers.edu/food-safety/"
  },
  {
    "id": "rg-032",
    "kind": "extension",
    "name": "New Mexico",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "NM",
    "website": "https://pubs.nmsu.edu/_e/"
  },
  {
    "id": "rg-033",
    "kind": "extension",
    "name": "New York",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "NY",
    "website": "https://cce.cornell.edu/program/nutrition"
  },
  {
    "id": "rg-034",
    "kind": "extension",
    "name": "North Carolina",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "NC",
    "website": "https://foodsafety.ces.ncsu.edu/"
  },
  {
    "id": "rg-035",
    "kind": "extension",
    "name": "North Dakota",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "ND",
    "website": "https://www.ag.ndsu.edu/food/food-safety"
  },
  {
    "id": "rg-036",
    "kind": "extension",
    "name": "Ohio",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "OH",
    "website": "https://fcs.osu.edu/programs/major-program-areas/healthy-people/food-safety"
  },
  {
    "id": "rg-037",
    "kind": "extension",
    "name": "Oklahoma",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "OK",
    "website": "https://extension.okstate.edu/topics/youth-family-health-and-home/cooking-and-food-safety/index.html"
  },
  {
    "id": "rg-038",
    "kind": "extension",
    "name": "Oregon",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "OR",
    "website": "https://extension.oregonstate.edu/food/safety-storage"
  },
  {
    "id": "rg-039",
    "kind": "extension",
    "name": "Pennsylvania",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "PA",
    "website": "https://extension.psu.edu/food-safety-and-quality"
  },
  {
    "id": "rg-040",
    "kind": "extension",
    "name": "Rhode Island",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "RI",
    "website": "https://web.uri.edu/foodsafety/"
  },
  {
    "id": "rg-041",
    "kind": "extension",
    "name": "South Carolina",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "SC",
    "website": "https://www.clemson.edu/extension/food/index.html"
  },
  {
    "id": "rg-042",
    "kind": "extension",
    "name": "South Dakota",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "SD",
    "website": "https://extension.sdstate.edu/"
  },
  {
    "id": "rg-043",
    "kind": "extension",
    "name": "Tennessee",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "TN",
    "website": "https://utextension.tennessee.edu/"
  },
  {
    "id": "rg-044",
    "kind": "extension",
    "name": "Texas",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "TX",
    "website": "https://agrilifeextension.tamu.edu/page/2/?s=food+safety"
  },
  {
    "id": "rg-045",
    "kind": "extension",
    "name": "Utah",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "UT",
    "website": "https://extension.usu.edu/foodsafety/"
  },
  {
    "id": "rg-046",
    "kind": "extension",
    "name": "Vermont",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "VT",
    "website": "https://www.uvm.edu/extension/necafs"
  },
  {
    "id": "rg-047",
    "kind": "extension",
    "name": "Virginia",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "VA",
    "website": "https://ext.vt.edu/food-health/food-safety.html"
  },
  {
    "id": "rg-048",
    "kind": "extension",
    "name": "Washington",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "WA",
    "website": "https://foodsafety.wsu.edu/"
  },
  {
    "id": "rg-049",
    "kind": "extension",
    "name": "West Virginia",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "WV",
    "website": "https://extension.wvu.edu/food-health/food-safety"
  },
  {
    "id": "rg-050",
    "kind": "extension",
    "name": "Wisconsin",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "WI",
    "website": "https://fyi.extension.wisc.edu/safefood/"
  },
  {
    "id": "rg-051",
    "kind": "extension",
    "name": "Wyoming",
    "notes": "State food safety extension program — free/low-cost help for food entrepreneurs.",
    "source": "USDA NIFA state extension list",
    "state": "WY",
    "website": "https://wyoextension.org/wrir/nutrition-food-safety/"
  },
  {
    "id": "rg-052",
    "kind": "licensing",
    "name": "Food Service Sanitation",
    "notes": "This resource covers food service sanitation laws and permits.",
    "source": "AFDO permit & license guide",
    "state": "AL",
    "website": "https://www.alabamapublichealth.gov/baldwin/food-scores.html#:~:text=The%20Public%20Health%20Laws%20of,Permits%20are%20not%20transferable."
  },
  {
    "id": "rg-053",
    "kind": "licensing",
    "name": "Food Safety Permit",
    "notes": "This site provides information regarding food safety permits for food and lodging businesses.",
    "source": "AFDO permit & license guide",
    "state": "AL",
    "website": "https://www.alabamapublichealth.gov/foodsafety/food-and-lodging.html"
  },
  {
    "id": "rg-054",
    "kind": "licensing",
    "name": "Forms and Fees",
    "notes": "This resource lists the forms and fees required for food establishment licensing.",
    "source": "AFDO permit & license guide",
    "state": "AK",
    "website": "https://dec.alaska.gov/eh/fss/food/"
  },
  {
    "id": "rg-055",
    "kind": "licensing",
    "name": "License Application",
    "notes": "This document is the application for a food establishment license.",
    "source": "AFDO permit & license guide",
    "state": "AZ",
    "website": "https://www.azdhs.gov/documents/preparedness/epidemiology-disease-control/food-safety-environmental-services/food-establishment-license-application.pdf"
  },
  {
    "id": "rg-056",
    "kind": "licensing",
    "name": "Food Protection FAQ",
    "notes": "This page covers frequently asked questions about food protection and permits.",
    "source": "AFDO permit & license guide",
    "state": "AR",
    "website": "https://healthy.arkansas.gov/programs-services/public-health-safety/food-protection-inspection-portal/food-protection-faq/"
  },
  {
    "id": "rg-057",
    "kind": "licensing",
    "name": "Licenses, Permits, Dairy Exemption Numbers, Registrations",
    "notes": "This resource covers various licenses, permits, and registrations for food-related businesses.",
    "source": "AFDO permit & license guide",
    "state": "CA",
    "website": "http://www.cdfa.ca.gov/ahfss/AHFSS_Licensing.html"
  },
  {
    "id": "rg-058",
    "kind": "licensing",
    "name": "Retail Food Program",
    "notes": "This form relates to the retail food program licensing requirements.",
    "source": "AFDO permit & license guide",
    "state": "CA",
    "website": "https://www.cdph.ca.gov/CDPH%20Document%20Library/ControlledForms/cdph8601.pdf"
  },
  {
    "id": "rg-059",
    "kind": "licensing",
    "name": "Applications, Forms, And Licenses",
    "notes": "This resource provides applications and forms for aquaculture-related food licenses.",
    "source": "AFDO permit & license guide",
    "state": "CT",
    "website": "https://portal.ct.gov/doag/aquaculture1/aquaculture/applications-forms-and-licenses"
  },
  {
    "id": "rg-060",
    "kind": "licensing",
    "name": "Agency Licenses And Permits",
    "notes": "This page lists various agency-issued licenses and permits for food businesses.",
    "source": "AFDO permit & license guide",
    "state": "CT",
    "website": "https://portal.ct.gov/doag/licensing/licenses/agency-licenses-and-permits"
  },
  {
    "id": "rg-061",
    "kind": "licensing",
    "name": "Business First Steps",
    "notes": "This site provides initial steps and permit information for food establishments.",
    "source": "AFDO permit & license guide",
    "state": "DE",
    "website": "https://firststeps.delaware.gov/food_establishments/"
  },
  {
    "id": "rg-062",
    "kind": "licensing",
    "name": "Food Protection",
    "notes": "This office manages food protection and regulatory licensing.",
    "source": "AFDO permit & license guide",
    "state": "DE",
    "website": "https://www.dhss.delaware.gov/dhss/dph/hsp/ofp.html"
  },
  {
    "id": "rg-063",
    "kind": "licensing",
    "name": "Retail Food License",
    "notes": "This guide covers the regulatory requirements for retail food licenses.",
    "source": "AFDO permit & license guide",
    "state": "DC",
    "website": "https://doh.dc.gov/sites/default/files/dc/sites/doh/publication/attachments/DC%20Restaurant%20Regulatory%20Guide%20Sheet%20FINAL%204-1-16%20%282%29.pdf"
  },
  {
    "id": "rg-064",
    "kind": "licensing",
    "name": "Food Permits",
    "notes": "This statute outlines the requirements for food permits.",
    "source": "AFDO permit & license guide",
    "state": "FL",
    "website": "http://www.leg.state.fl.us/statutes/index.cfm?App_mode=Display_Statute&Search_String=&URL=0500-0599/0500/Sections/0500.12.html"
  },
  {
    "id": "rg-065",
    "kind": "licensing",
    "name": "Retail Food Establishments",
    "notes": "This resource provides information on obtaining a retail food establishment permit.",
    "source": "AFDO permit & license guide",
    "state": "FL",
    "website": "https://www.fdacs.gov/Business-Services/Food/Food-Establishments/Retail-Food-Establishment-Permit"
  },
  {
    "id": "rg-066",
    "kind": "licensing",
    "name": "Food Safety and Sanitation",
    "notes": "This site provides resources for food safety permits and sanitation compliance.",
    "source": "AFDO permit & license guide",
    "state": "FL",
    "website": "http://www.floridahealth.gov/environmental-health/food-safety-and-sanitation/index.html"
  },
  {
    "id": "rg-067",
    "kind": "licensing",
    "name": "Food Establishment Licenses",
    "notes": "This page details the licensing requirements for food establishment retailers.",
    "source": "AFDO permit & license guide",
    "state": "GA",
    "website": "https://agr.georgia.gov/food-establishment-licenses-retailers"
  },
  {
    "id": "rg-068",
    "kind": "licensing",
    "name": "Licenses",
    "notes": "This general portal provides information on various food-related business licenses.",
    "source": "AFDO permit & license guide",
    "state": "GA",
    "website": "https://agr.georgia.gov/licensing"
  },
  {
    "id": "rg-069",
    "kind": "licensing",
    "name": "Permit Application For Mobile/Extended Food Service Units",
    "notes": "This is the permit application for mobile and extended food service units.",
    "source": "AFDO permit & license guide",
    "state": "GA",
    "website": "https://dph.georgia.gov/sites/dph.georgia.gov/files/related_files/site_page/EnvHealthFoodMobileExtendedFSUnitPermitApplication.pdf"
  },
  {
    "id": "rg-070",
    "kind": "licensing",
    "name": "Permits",
    "notes": "This page hosts various permit applications for food-related operations.",
    "source": "AFDO permit & license guide",
    "state": "HI",
    "website": "https://health.hawaii.gov/san/permit-applications/"
  },
  {
    "id": "rg-071",
    "kind": "licensing",
    "name": "ISDA Licenses, Registrations And Certificates",
    "notes": "This site covers the necessary licenses and registrations for food business entities.",
    "source": "AFDO permit & license guide",
    "state": "ID",
    "website": "https://agri.idaho.gov/fsma-hemp-hops/"
  },
  {
    "id": "rg-072",
    "kind": "licensing",
    "name": "Food Handler License",
    "notes": "This resource details the requirements for food handler licenses.",
    "source": "AFDO permit & license guide",
    "state": "IL",
    "website": "https://dph.illinois.gov/topics-services/food-safety/food-handler-training.html"
  },
  {
    "id": "rg-073",
    "kind": "licensing",
    "name": "Application For Milk Vehicle For A Two Year Permit",
    "notes": "This document is an application for a milk vehicle permit.",
    "source": "AFDO permit & license guide",
    "state": "IA",
    "website": "https://iowaagriculture.gov/dairy-products-control-bureau"
  },
  {
    "id": "rg-074",
    "kind": "licensing",
    "name": "Food Establishments",
    "notes": "This portal covers business licensing for food establishments.",
    "source": "AFDO permit & license guide",
    "state": "IA",
    "website": "https://dial.iowa.gov/licenses"
  },
  {
    "id": "rg-075",
    "kind": "licensing",
    "name": "Accounts Receivable and Licensing",
    "notes": "This site provides license information for food and lodging establishments.",
    "source": "AFDO permit & license guide",
    "state": "KS",
    "website": "https://www.agriculture.ks.gov/licenses/food-and-lodging-applications-and-licenses/license-information-food-safety"
  },
  {
    "id": "rg-076",
    "kind": "licensing",
    "name": "Retail Food Permitting for New Business",
    "notes": "This page provides guidance on retail food permitting for new businesses.",
    "source": "AFDO permit & license guide",
    "state": "LA",
    "website": "https://ldh.la.gov/index.cfm/page/632"
  },
  {
    "id": "rg-077",
    "kind": "licensing",
    "name": "Permits And Licenses",
    "notes": "This page lists state-required permits and licenses for food businesses.",
    "source": "AFDO permit & license guide",
    "state": "ME",
    "website": "http://www.maine.gov/dacf/qar/permits_and_licenses/index.shtml"
  },
  {
    "id": "rg-078",
    "kind": "licensing",
    "name": "Restaurants And Eating Places",
    "notes": "This resource provides regulatory information for operating restaurants.",
    "source": "AFDO permit & license guide",
    "state": "ME",
    "website": "http://www.maine.gov/dhhs/mecdc/environmental-health/el/business/business-answers-restaurants.htm"
  },
  {
    "id": "rg-079",
    "kind": "licensing",
    "name": "Licenses And Permits",
    "notes": "This site provides a collection of agricultural and food business licenses and permits.",
    "source": "AFDO permit & license guide",
    "state": "MD",
    "website": "http://mda.maryland.gov/Pages/Licenses-and-Permits.aspx"
  },
  {
    "id": "rg-080",
    "kind": "licensing",
    "name": "How To Apply For A Food Service License",
    "notes": "This guide explains the application process for food service licenses.",
    "source": "AFDO permit & license guide",
    "state": "MI",
    "website": "http://www.michigan.gov/mdard/0,4610,7-125-1569_16958_16977---,00.html"
  },
  {
    "id": "rg-081",
    "kind": "licensing",
    "name": "Licensing, Certification & Registration",
    "notes": "This section covers licensing and registration requirements for food businesses.",
    "source": "AFDO permit & license guide",
    "state": "MI",
    "website": "http://www.michigan.gov/mdard/0,4610,7-125-1569_16958---,00.html"
  },
  {
    "id": "rg-082",
    "kind": "licensing",
    "name": "Dairy Licensing In Michigan",
    "notes": "This resource covers specific licensing requirements for dairy businesses.",
    "source": "AFDO permit & license guide",
    "state": "MI",
    "website": "http://www.michigan.gov/mdard/0,1607,7-125-1569_16958_16960---,00.html"
  },
  {
    "id": "rg-083",
    "kind": "licensing",
    "name": "License Type Guide With Fees",
    "notes": "This guide provides information on license types and associated fees.",
    "source": "AFDO permit & license guide",
    "state": "MI",
    "website": "http://www.michigan.gov/mdard/0,4610,7-125-1569_16958_16974-11890--,00.html"
  },
  {
    "id": "rg-084",
    "kind": "licensing",
    "name": "Bed And Breakfast License",
    "notes": "This page outlines the requirements for a bed and breakfast food license.",
    "source": "AFDO permit & license guide",
    "state": "MN",
    "website": "https://www.health.state.mn.us/communities/environment/food/license/bedbreakfast.html"
  },
  {
    "id": "rg-085",
    "kind": "licensing",
    "name": "Food, Pools, and Lodging Services",
    "notes": "This site covers licensing for various food and lodging services.",
    "source": "AFDO permit & license guide",
    "state": "MN",
    "website": "https://www.web.health.state.mn.us/communities/environment/food/license"
  },
  {
    "id": "rg-086",
    "kind": "licensing",
    "name": "Retail Food Handler / Retail Mobile Food Handler Licenses",
    "notes": "This link leads to licensing information for retail and mobile food handlers.",
    "source": "AFDO permit & license guide",
    "state": "MN",
    "website": "https://mn.gov/elicense/a-z/?id=1083-231285#/list/appId//filterType//filterValue//page/1/sort//order/"
  },
  {
    "id": "rg-087",
    "kind": "licensing",
    "name": "What Is A Dairy Plant",
    "notes": "This resource explains licensing requirements for dairy plants.",
    "source": "AFDO permit & license guide",
    "state": "MN",
    "website": "https://www.mda.state.mn.us/food-feed/dairy-plants"
  },
  {
    "id": "rg-088",
    "kind": "licensing",
    "name": "Special Event Food Stand License Application Guide",
    "notes": "This guide covers the license application for temporary food stands.",
    "source": "AFDO permit & license guide",
    "state": "MN",
    "website": "https://www.mda.state.mn.us/food-feed/special-event-food-stand-license-application-guide"
  },
  {
    "id": "rg-089",
    "kind": "licensing",
    "name": "Permit Requirements For Farmers Market Vendors",
    "notes": "This page explains permit requirements for vendors at farmers markets.",
    "source": "AFDO permit & license guide",
    "state": "MS",
    "website": "https://www.mdac.ms.gov/bureaus-departments/market-development/mississippi-certified-farmers-markets-program/mississippi-farmers-markets-permit-requirements/"
  },
  {
    "id": "rg-090",
    "kind": "licensing",
    "name": "Regulations",
    "notes": "These regulations cover the requirements for food permits and licensing.",
    "source": "AFDO permit & license guide",
    "state": "MS",
    "website": "http://msdh.ms.gov/msdhsite/_static/30,0,77.html"
  },
  {
    "id": "rg-091",
    "kind": "licensing",
    "name": "Frozen Desserts",
    "notes": "This page outlines licensing requirements for frozen dessert manufacturers.",
    "source": "AFDO permit & license guide",
    "state": "MO",
    "website": "https://health.mo.gov/business-professionals/food-safety"
  },
  {
    "id": "rg-092",
    "kind": "licensing",
    "name": "Licenses",
    "notes": "This document details the regulations and license requirements for food businesses.",
    "source": "AFDO permit & license guide",
    "state": "MT",
    "website": "https://rules.mt.gov/gateway/RuleNo.asp?RN=37.110.238"
  },
  {
    "id": "rg-093",
    "kind": "licensing",
    "name": "Licensing, Permits & Registrations",
    "notes": "This page provides access to forms for food business licenses and permits.",
    "source": "AFDO permit & license guide",
    "state": "NE",
    "website": "http://www.nda.nebraska.gov/forms/index.html"
  },
  {
    "id": "rg-094",
    "kind": "licensing",
    "name": "Permits: Food Establishments",
    "notes": "This site covers the permit requirements for food establishments.",
    "source": "AFDO permit & license guide",
    "state": "NV",
    "website": "https://agri.nv.gov/Animals/Food_Safety/Food_Safety_Program/"
  },
  {
    "id": "rg-095",
    "kind": "licensing",
    "name": "Forms: Temporary Food Establishments At Special Events",
    "notes": "This resource provides forms for temporary food establishment permits.",
    "source": "AFDO permit & license guide",
    "state": "NV",
    "website": "https://www.southernnevadahealthdistrict.org/permits-and-regulations/special-events/"
  },
  {
    "id": "rg-096",
    "kind": "licensing",
    "name": "Licensing & Applications",
    "notes": "This page covers licensing and applications for dairy-related food operations.",
    "source": "AFDO permit & license guide",
    "state": "NH",
    "website": "https://www.dhhs.nh.gov/programs-services/environmental-health-and-you/food-protection/dairy-farms-and-dairy-plants"
  },
  {
    "id": "rg-097",
    "kind": "licensing",
    "name": "New Licenses or Change Existing License",
    "notes": "This resource explains how to apply for or modify a food license.",
    "source": "AFDO permit & license guide",
    "state": "NH",
    "website": "https://www.dhhs.nh.gov/programs-services/environmental-health-and-you/food-protection/apply-new-license-or-change-existing"
  },
  {
    "id": "rg-098",
    "kind": "licensing",
    "name": "Food and Drug Safety",
    "notes": "This site offers information regarding payments for food and drug safety permits.",
    "source": "AFDO permit & license guide",
    "state": "NJ",
    "website": "https://www.nj.gov/health/ceohs/food-drug-safety/epayments.shtml"
  },
  {
    "id": "rg-099",
    "kind": "licensing",
    "name": "Food Permit Applications",
    "notes": "This page hosts applications for food permits.",
    "source": "AFDO permit & license guide",
    "state": "NM",
    "website": "https://www.env.nm.gov/foodprogram/retail-food-application/"
  },
  {
    "id": "rg-100",
    "kind": "licensing",
    "name": "Food Business Licensing",
    "notes": "This site covers the licensing requirements for food businesses in New York.",
    "source": "AFDO permit & license guide",
    "state": "NY",
    "website": "https://www.agriculture.ny.gov/food-business-licensing"
  },
  {
    "id": "rg-101",
    "kind": "licensing",
    "name": "Wholesale Frozen Dessert Manufactures & Handlers Two Year License Application",
    "notes": "This is the application form for a wholesale frozen dessert license.",
    "source": "AFDO permit & license guide",
    "state": "NY",
    "website": "https://www.agriculture.ny.gov/system/files/documents/2019/06/DMC%2072%20FROZEN%20DESSERT%20APPLICATION.pdf"
  },
  {
    "id": "rg-102",
    "kind": "licensing",
    "name": "Home Based Foods",
    "notes": "This resource explains permit requirements for home-based food businesses.",
    "source": "AFDO permit & license guide",
    "state": "NC",
    "website": "https://www.ncagr.gov/divisions/food-drug-protection/food-program/fdpd-food-program-home-processor"
  },
  {
    "id": "rg-103",
    "kind": "licensing",
    "name": "Licenses and Permits",
    "notes": "This page guides food businesses through the license and permit application process.",
    "source": "AFDO permit & license guide",
    "state": "NC",
    "website": "https://www.ncagr.gov/divisions/food-drug-protection-division/food-program/food-program-food/starting-food-business"
  },
  {
    "id": "rg-104",
    "kind": "licensing",
    "name": "State License and Inspection",
    "notes": "This guide covers the state licensing and inspection requirements for local food.",
    "source": "AFDO permit & license guide",
    "state": "ND",
    "website": "https://www.ndsu.edu/agriculture/extension/publications/guide-buying-and-selling-local-food"
  },
  {
    "id": "rg-105",
    "kind": "licensing",
    "name": "Licenses",
    "notes": "This page provides information on various food safety licenses.",
    "source": "AFDO permit & license guide",
    "state": "OH",
    "website": "https://agri.ohio.gov/wps/portal/gov/oda/divisions/food-safety/licenses/"
  },
  {
    "id": "rg-106",
    "kind": "licensing",
    "name": "About Food Safety License",
    "notes": "This resource provides detailed information about food safety licensing.",
    "source": "AFDO permit & license guide",
    "state": "OR",
    "website": "https://www.oregon.gov/oda/programs/foodsafety/fslicensing/pages/aboutlicenses.aspx"
  },
  {
    "id": "rg-107",
    "kind": "licensing",
    "name": "Fee Schedule",
    "notes": "This document lists the fee schedule for food licenses.",
    "source": "AFDO permit & license guide",
    "state": "OR",
    "website": "https://www.oregon.gov/oda/shared/Documents/Publications/FoodSafety/FoodLicenseFeeSchedule.pdf"
  },
  {
    "id": "rg-108",
    "kind": "licensing",
    "name": "License Directory",
    "notes": "This is a searchable directory for food business licenses.",
    "source": "AFDO permit & license guide",
    "state": "OR",
    "website": "http://licenseinfo.oregon.gov/index.cfm?fuseaction=license_seng&link_item_id=13904"
  },
  {
    "id": "rg-109",
    "kind": "licensing",
    "name": "Farmers Market Vendor",
    "notes": "This resource covers licensing requirements for farmers market vendors.",
    "source": "AFDO permit & license guide",
    "state": "PA",
    "website": "https://www.agriculture.pa.gov/consumer_protection/FoodSafety/Retail%20Food/Pages/Farmers-Markets.aspx"
  },
  {
    "id": "rg-110",
    "kind": "licensing",
    "name": "Frozen Dessert Applicant",
    "notes": "This document is the application packet for a frozen dessert license.",
    "source": "AFDO permit & license guide",
    "state": "PA",
    "website": "http://www.agriculture.pa.gov/consumer_protection/FoodSafety/manufacturing-packing-holding-distribution/Frozen%20Dessert/Documents/Application%20Packet-%20Frozen%20Dessert%20License.pdf"
  },
  {
    "id": "rg-111",
    "kind": "licensing",
    "name": "Mobile Food Facility Operation Guide",
    "notes": "This guide outlines the requirements for operating a mobile food facility.",
    "source": "AFDO permit & license guide",
    "state": "PA",
    "website": "http://www.agriculture.pa.gov/consumer_protection/FoodSafety/Retail%20Food/Documents/Mobile%20Food%20Facility%20Operation%20Guide.pdf"
  },
  {
    "id": "rg-112",
    "kind": "licensing",
    "name": "Retail Foods Facilities And Restaurants",
    "notes": "This page provides guidance on licensing for retail food facilities and restaurants.",
    "source": "AFDO permit & license guide",
    "state": "PA",
    "website": "http://www.agriculture.pa.gov/consumer_protection/FoodSafety/Retail%20Food/Retail%20Foods%20Facilities%20and%20Restaurants/Pages/default.aspx"
  },
  {
    "id": "rg-113",
    "kind": "licensing",
    "name": "Food Service Licensing",
    "notes": "This page details the licensing process for food service businesses.",
    "source": "AFDO permit & license guide",
    "state": "RI",
    "website": "https://health.ri.gov/licenses/detail.php?id=256"
  },
  {
    "id": "rg-114",
    "kind": "licensing",
    "name": "Food Processing Licensing",
    "notes": "This page details the licensing process for food processing businesses.",
    "source": "AFDO permit & license guide",
    "state": "RI",
    "website": "https://health.ri.gov/licenses/detail.php?id=254"
  },
  {
    "id": "rg-115",
    "kind": "licensing",
    "name": "Food Permit",
    "notes": "This guide explains how to apply for a retail food establishment permit.",
    "source": "AFDO permit & license guide",
    "state": "SC",
    "website": "https://agriculture.sc.gov/divisions/consumer-protection/retail-food-safety/how-to-apply-for-a-retail-food-establishment-permit/"
  },
  {
    "id": "rg-116",
    "kind": "licensing",
    "name": "Food Safety Compliance",
    "notes": "This page provides information on food safety compliance and licensing.",
    "source": "AFDO permit & license guide",
    "state": "SC",
    "website": "https://agriculture.sc.gov/permits-and-inspections/"
  },
  {
    "id": "rg-117",
    "kind": "licensing",
    "name": "Food Service Licensing",
    "notes": "This site covers the licensing requirements for food service businesses.",
    "source": "AFDO permit & license guide",
    "state": "SD",
    "website": "https://doh.sd.gov/topics/food-lodging-safety/licensure-and-codes/food-service/"
  },
  {
    "id": "rg-118",
    "kind": "licensing",
    "name": "Food Service Establishment",
    "notes": "This resource provides information on licensing for food service establishments.",
    "source": "AFDO permit & license guide",
    "state": "TN",
    "website": "https://www.tn.gov/agriculture/consumers/food-safety.html"
  },
  {
    "id": "rg-119",
    "kind": "licensing",
    "name": "Food Manufacturers, Wholesalers, And Warehouses",
    "notes": "This site provides permit and licensing information for food manufacturers and wholesalers.",
    "source": "AFDO permit & license guide",
    "state": "TX",
    "website": "https://dshs.texas.gov/foods/default.aspx"
  },
  {
    "id": "rg-120",
    "kind": "licensing",
    "name": "License Application, Fees, Regulations, Guidelines",
    "notes": "This guide covers license applications and regulations for food businesses.",
    "source": "AFDO permit & license guide",
    "state": "VT",
    "website": "http://healthvermont.gov/enviro/food_lodge/food_lodge_guide.aspx#general"
  },
  {
    "id": "rg-121",
    "kind": "licensing",
    "name": "Food Establishment Operator Information",
    "notes": "This operator guide provides information on temporary food establishment permits.",
    "source": "AFDO permit & license guide",
    "state": "VA",
    "website": "https://www.vdh.virginia.gov/content/uploads/sites/89/2023/01/TFE-Operator-Guide.pdf"
  },
  {
    "id": "rg-122",
    "kind": "licensing",
    "name": "Certification, License, Permit, And Registration Summary Descriptions",
    "notes": "This resource describes the various licenses and permits required for food businesses.",
    "source": "AFDO permit & license guide",
    "state": "WA",
    "website": "https://agr.wa.gov/services/licenses-permits-and-certificates/summary-descriptions"
  },
  {
    "id": "rg-123",
    "kind": "licensing",
    "name": "Food Processing Plant License",
    "notes": "This page provides details on obtaining a food processing plant license.",
    "source": "AFDO permit & license guide",
    "state": "WA",
    "website": "http://apps.oria.wa.gov/permithandbook/permitdetail.asp?id=147"
  },
  {
    "id": "rg-124",
    "kind": "licensing",
    "name": "Food Sanitation",
    "notes": "This site covers food sanitation laws and permit requirements.",
    "source": "AFDO permit & license guide",
    "state": "WV",
    "website": "https://www.wvdhhr.org/phs/food/index.asp#:~:text=The%20West%20Virginia%20Bureau%20for,the%20following%20June%2030th."
  },
  {
    "id": "rg-125",
    "kind": "licensing",
    "name": "Food, Dairy, and Retail Food Licenses",
    "notes": "This page provides licensing information for food and dairy businesses.",
    "source": "AFDO permit & license guide",
    "state": "WI",
    "website": "https://datcp.wi.gov/Pages/Licenses_Permits/FoodLicenses.aspx"
  },
  {
    "id": "rg-126",
    "kind": "licensing",
    "name": "Requirements For Plan Submission; License Application And Issuance; Inspection",
    "notes": "This document details the requirements for food license applications and inspections.",
    "source": "AFDO permit & license guide",
    "state": "WY",
    "website": "https://agriculture.wy.gov/corecode/uploads/document6/uploaded_pdfs/corecode/chapt22012_1284.pdf"
  },
  {
    "id": "rg-127",
    "kind": "federal",
    "name": "FDA Food Facility Registration",
    "notes": "Federal registration required for most facilities that manufacture, process, pack, or hold food for US sale — free, renewed every even year.",
    "source": "FDA.gov",
    "state": "",
    "website": "https://www.fda.gov/food/guidance-regulation-food-and-dietary-supplements/registration-food-facilities-and-other-submissions"
  },
  {
    "id": "rg-128",
    "kind": "federal",
    "name": "AFDO Directory of State & Local Officials",
    "notes": "Lookup tool to find your state and local food regulatory officials.",
    "source": "AFDO",
    "state": "",
    "website": "https://www.afdo.org/directories/dslo/"
  },
  {
    "id": "rg-129",
    "kind": "federal",
    "name": "National Ag Law Center — Cottage Food Laws",
    "notes": "State-by-state compilation of cottage food laws for home-based sellers.",
    "source": "National Agricultural Law Center",
    "state": "",
    "website": "https://nationalaglawcenter.org/state-compilations/cottagefood/"
  }
];
